/*
    Add here your own custom javascript
*/

// Content with Media - Video Player Functionality
document.addEventListener('DOMContentLoaded', function() {
    // Initialize all video players
    const videoContainers = document.querySelectorAll('.video-container');
    
    videoContainers.forEach(function(container) {
        const video = container.querySelector('video');
        const playButton = container.querySelector('.custom-play-button');
        
        if (video && playButton) {
            // Show play button initially
            playButton.style.display = 'flex';
            
            // Handle play button click
            playButton.addEventListener('click', function() {
                if (video.paused) {
                    video.play().then(function() {
                        playButton.style.display = 'none';
                    }).catch(function(error) {
                        console.log('Video play failed:', error);
                    });
                }
            });
            
            // Handle video events
            video.addEventListener('play', function() {
                playButton.style.display = 'none';
            });
            
            video.addEventListener('pause', function() {
                playButton.style.display = 'flex';
            });
            
            video.addEventListener('ended', function() {
                playButton.style.display = 'flex';
            });
            
            // Handle video click to pause
            video.addEventListener('click', function() {
                if (!video.paused) {
                    video.pause();
                }
            });
        }
    });
});

// Legacy function for backwards compatibility
function toggleVideo(button) {
    const videoContainer = button.parentElement;
    const video = videoContainer.querySelector('video');
    
    if (video && video.paused) {
        video.play().then(function() {
            button.style.display = 'none';
        }).catch(function(error) {
            console.log('Video play failed:', error);
        });
    }
}

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()
